import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#333",
        color: "white",
        padding: "40px 0",
        marginTop: "50px"
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          padding: "0 20px"
        }}
      >
        {/* Column 1 - About */}
        <div style={{ flex: 1, marginRight: "30px" }}>
          <h3 style={{ marginBottom: "15px", color: "white" }}>
            About 808 Cleanups
          </h3>
          <p style={{ lineHeight: "1.6", fontSize: "14px" }}>
            808 Cleanups is dedicated to keeping Hawaii's beaches and
            communities clean. Join our mission to preserve the natural beauty
            of the islands through community-driven cleanup efforts.
          </p>
        </div>

        {/* Column 2 - Quick Links */}
        <div style={{ flex: 1, marginRight: "30px" }}>
          <h3 style={{ marginBottom: "15px", color: "white" }}>Quick Links</h3>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <li style={{ marginBottom: "8px" }}>
              <a
                href="https://play.google.com/store/apps/details?id=com.app808cleanups&hl=en_US"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontSize: "14px"
                }}
              >
                Get Android App
              </a>
            </li>
            <li style={{ marginBottom: "8px" }}>
              <a
                href="https://apps.apple.com/us/app/808-cleanups/id1464605740"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontSize: "14px"
                }}
              >
                Get iOS App
              </a>
            </li>
            <li style={{ marginBottom: "8px" }}>
              <a
                href="https://808cleanups.org/donate/"
                style={{
                  color: "white",
                  textDecoration: "none",
                  fontSize: "14px"
                }}
              >
                Donate
              </a>
            </li>
          </ul>
        </div>

        {/* Column 3 - Contact */}
        <div style={{ flex: 1 }}>
          <h3 style={{ marginBottom: "15px", color: "white" }}>Get in Touch</h3>
          <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
            <p style={{ marginBottom: "8px" }}>
              <strong>Email:</strong> 808cleanups@gmail.com
            </p>
            <p style={{ marginBottom: "8px" }}>
              <strong>Follow us:</strong>
            </p>
            <div style={{ marginTop: "10px" }}>
              <a
                href="https://www.facebook.com/groups/808cleanups/"
                target="_blank"
                style={{
                  color: "white",
                  marginRight: "15px",
                  fontSize: "16px"
                }}
              >
                📘 Facebook
              </a>
              <a
                href="https://www.instagram.com/808cleanups/?hl=en"
                target="_blank"
                style={{
                  color: "white",
                  marginRight: "15px",
                  fontSize: "16px"
                }}
              >
                📷 Instagram
              </a>
              <a
                href="https://twitter.com/808cleanups?lang=en"
                target="_blank"
                style={{ color: "white", fontSize: "16px" }}
              >
                🐦 Twitter
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div
        style={{
          textAlign: "center",
          marginTop: "30px",
          paddingTop: "20px",
          borderTop: "1px solid rgba(255,255,255,0.2)",
          fontSize: "12px",
          opacity: 0.8
        }}
      >
        808 Cleanups a 501(c)(3) nonprofit organization
      </div>
    </footer>
  );
};

export default Footer;
